module.exports = __webpack_public_path__ + "img/elements_graphiques-10.2e8d2ebb.png";